var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditingFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24984 9.16667C9.26236 9.16667 10.0832 8.34586 10.0832 7.33333C10.0832 6.32081 9.26236 5.5 8.24984 5.5C7.23732 5.5 6.4165 6.32081 6.4165 7.33333C6.4165 8.34586 7.23732 9.16667 8.24984 9.16667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9168 1.83398H8.25016C3.66683 1.83398 1.8335 3.66732 1.8335 8.25065V13.7507C1.8335 18.334 3.66683 20.1673 8.25016 20.1673H13.7502C18.3335 20.1673 20.1668 18.334 20.1668 13.7507V9.16732",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.545 2.37361L14.2175 5.70111C14.0891 5.82945 13.9608 6.07695 13.9425 6.26028L13.7591 7.53445C13.695 7.99278 14.0158 8.31361 14.4741 8.24945L15.7483 8.06611C15.9225 8.03861 16.1791 7.91945 16.3075 7.79111L19.635 4.46361C20.2125 3.88611 20.4783 3.22611 19.635 2.38278C18.7825 1.52111 18.1225 1.79611 17.545 2.37361Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0684 2.85156C17.3525 3.8599 18.1409 4.64823 19.1492 4.9324",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44727 17.3712L6.96643 14.337C7.6906 13.8512 8.7356 13.9062 9.38643 14.4653L9.68893 14.7312C10.4039 15.3453 11.5589 15.3453 12.2739 14.7312L16.0873 11.4587C16.8023 10.8445 17.9573 10.8445 18.6723 11.4587L20.1664 12.742",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditingFlow);
export default __webpack_public_path__ + "static/media/editing-flow.c015b96cb22e20c5c9e40e8fef443d7b.svg";
export { ForwardRef as ReactComponent };